export const formInitialValues = {
  commodityCode: null,
  commodityDescription: '',
  commercialDescription: '',
  manufacturerName: '',
  countryOfOriginCode: null,
  packageNumber: '',
  packageTypeCode: null,
  packageMark: '',
  grossMass: '',
  netMass: '',
  quotaType: null,
  quotaType2: null,
  requestedAmount: '',
  requestedAmount2: '',
  approvedAmount: '',
  approvedAmount2: '',
  requestedUomCode: null,
  requestedUomCode2: null,
  approvedUomCode: null,
  approvedUomCode2: null,
  remainingAmount: '',
  remainingAmount2: '',
  itemInvoiceAmountInForeignCurrency: '',
  itemInvoiceAmountInNationalCurrency: '',
  packages: [],
  treatments: [],
  parentItemId: null,
};
